/* Gifting pages: budget filter, tier picker, gallery, countdown, doors, quote estimate */
(function () {
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }

  /* budget filter */
  qsa('[data-gf-filter]').forEach(function (box) {
    var target = qs(box.getAttribute('data-gf-filter'));
    if (!target) return;
    box.addEventListener('click', function (e) {
      var p = e.target.closest('.gf-pill');
      if (!p) return;
      qsa('.gf-pill', box).forEach(function (x) { x.classList.remove('is-on'); });
      p.classList.add('is-on');
      var f = p.getAttribute('data-f');
      qsa('[data-gf-t]', target).forEach(function (c) {
        var tags = (c.getAttribute('data-gf-t') || '').split(' ');
        c.style.display = (!f || tags.indexOf(f) > -1) ? '' : 'none';
      });
    });
  });

  /* gallery thumbs */
  qsa('[data-gf-gallery]').forEach(function (g) {
    var main = qs('[data-gf-main]', g);
    qsa('[data-gf-th]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        qsa('[data-gf-th]', g).forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        var src = b.getAttribute('data-src');
        if (main && src) {
          main.style.opacity = 0;
          setTimeout(function () { main.src = src; main.removeAttribute('srcset'); main.style.opacity = 1; }, 120);
        }
      });
    });
  });

  /* tier picker: price, contents column, doors */
  qsa('[data-gf-product]').forEach(function (root) {
    var priceEl = qs('[data-gf-price]', root);
    var radios = qsa('input[name="id"][type="radio"]', root);
    function sync() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      var idx = radios.indexOf(r);
      if (priceEl && r.getAttribute('data-money')) priceEl.textContent = r.getAttribute('data-money');
      qsa('[data-col]', root).forEach(function (c) { c.classList.toggle('is-hl', Number(c.getAttribute('data-col')) === idx + 1); });
      var doors = qs('[data-gf-doors]', root);
      var n = Number(r.getAttribute('data-doors'));
      if (doors && n > 0 && doors.children.length !== n) { buildDoors(doors, n); }
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  });

  /* countdown + auto close */
  qsa('[data-gf-count]').forEach(function (el) {
    var end = Number(el.getAttribute('data-end')) * 1000;
    var closedLabel = el.getAttribute('data-closed') || 'Orders closed';
    var root = el.closest('[data-gf-product]') || document;
    function close() {
      el.innerHTML = '<i></i>' + closedLabel;
      qsa('[data-gf-add]', root).forEach(function (b) { b.disabled = true; });
      qsa('[data-gf-closed]', root).forEach(function (b) { b.hidden = false; });
      qsa('[data-gf-open-only]', root).forEach(function (b) { b.hidden = true; });
    }
    function tick() {
      var d = end - Date.now();
      if (d < 0) { close(); return false; }
      var D = Math.floor(d / 864e5), H = Math.floor(d % 864e5 / 36e5), M = Math.floor(d % 36e5 / 6e4), S = Math.floor(d % 6e4 / 1e3);
      el.innerHTML = '<i></i>Order closes in ' + D + 'd ' + ('0' + H).slice(-2) + 'h ' + ('0' + M).slice(-2) + 'm ' + ('0' + S).slice(-2) + 's';
      return true;
    }
    if (tick()) { var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); }
  });

  /* doors */
  var opened = {};
  function buildDoors(el, n) {
    var h = '';
    for (var i = 1; i <= n; i++) { h += '<button type="button" class="gf-door" aria-label="Door ' + i + '">' + i + '</button>'; }
    el.innerHTML = h;
    opened = {};
    var note = qs('[data-gf-dnote]');
    if (note) note.textContent = 'Tap a door. 0 of ' + n + ' opened.';
  }
  qsa('[data-gf-doors]').forEach(function (el) {
    var n = Number(el.getAttribute('data-gf-doors')) || 24;
    if (!el.children.length) buildDoors(el, n);
    el.addEventListener('click', function (e) {
      var x = e.target.closest('.gf-door');
      if (!x || x.classList.contains('is-open')) return;
      var i = Array.prototype.indexOf.call(el.children, x);
      x.classList.add('is-open');
      x.innerHTML = '<b>Day ' + (i + 1) + '</b><i>A new country</i>';
      opened[i] = 1;
      var note = qs('[data-gf-dnote]');
      if (note) note.textContent = 'Tap a door. ' + Object.keys(opened).length + ' of ' + el.children.length + ' opened.';
    });
  });

  /* corporate quote form: card buttons pre-fill the notes, empty notes still send */
  qsa('[data-gf-qform]').forEach(function (form) {
    var notes = qs('[data-gf-notes]', form);
    var qty = qs('[data-gf-qty]', form);
    var min = parseInt(qty && qty.getAttribute('min'), 10) || 10;
    qsa('[data-gf-qadd]', document).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (notes) {
          var line = 'Interested in: Dhs. ' + b.getAttribute('data-gf-qadd') + ' box.';
          notes.value = notes.value.replace(/^Interested in: Dhs\. \d+ box\.\s*/, '');
          notes.value = (line + (notes.value ? ' ' + notes.value : '')).trim();
        }
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (qty) { setTimeout(function () { qty.focus({ preventScroll: true }); }, 600); }
      });
    });
    if (qty) {
      qty.addEventListener('input', function () { qty.setCustomValidity(''); });
      qty.addEventListener('invalid', function () {
        if (qty.validity.rangeUnderflow) { qty.setCustomValidity('Corporate orders start at ' + min + ' boxes.'); }
      });
    }
    form.addEventListener('submit', function () {
      if (notes && !notes.value.trim()) { notes.value = 'No notes.'; }
    });
  });
  /* notify forms: send without leaving the page */
  qsa('form[data-gf-notify]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = qs('button', f);
      var old = btn.textContent;
      btn.disabled = true;
      fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
        .then(function () {
          btn.textContent = 'On the list ✓';
          btn.style.background = 'var(--coral)';
          btn.style.color = '#fff';
          qs('input[type="email"]', f).value = '';
        })
        .catch(function () { btn.disabled = false; btn.textContent = old; });
    });
  });
})();
